var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "130px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "领取人姓名", prop: "receiveUserName" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "300px" },
                        attrs: { disabled: "", maxlength: "10" },
                        model: {
                          value: _vm.childData.receiveUserName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "receiveUserName", $$v)
                          },
                          expression: "childData.receiveUserName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "领取人联系方式",
                        prop: "receiveUserPhone"
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "300px" },
                        attrs: { disabled: "", maxlength: "11" },
                        model: {
                          value: _vm.childData.receiveUserPhone,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "receiveUserPhone", $$v)
                          },
                          expression: "childData.receiveUserPhone"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "领取人住址", prop: "receiveUserAdder" }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "300px" },
                        attrs: { disabled: "", maxlength: "20" },
                        model: {
                          value: _vm.childData.receiveUserAdder,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "receiveUserAdder", $$v)
                          },
                          expression: "childData.receiveUserAdder"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "领取时间", prop: "receiveDate" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "300px" },
                        attrs: {
                          disabled: "",
                          type: "datetime",
                          format: "yyyy-MM-dd HH:mm",
                          "value-format": "yyyy-MM-dd HH:mm",
                          placeholder: "选择领取时间"
                        },
                        model: {
                          value: _vm.childData.receiveDate,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "receiveDate", $$v)
                          },
                          expression: "childData.receiveDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("table.remark") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "300px" },
                        attrs: {
                          clearable: "",
                          placeholder: "请输入备注",
                          maxlength: "100",
                          type: "textarea",
                          autosize: { minRows: 3, maxRows: 3 }
                        },
                        model: {
                          value: _vm.childData.auditRemark,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "auditRemark", $$v)
                          },
                          expression: "childData.auditRemark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "danger", icon: "el-icon-close" },
              on: {
                click: function($event) {
                  return _vm.handApproval(1)
                }
              }
            },
            [_vm._v("确认不通过")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "success", icon: "el-icon-check" },
              on: {
                click: function($event) {
                  return _vm.handApproval(0)
                }
              }
            },
            [_vm._v("确认通过")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }